import React from "react";
import styled from "styled-components";
import { withPrefix } from "gatsby";
import BaitToPlateEntityTypeIcon from "./BaitToPlateEntityTypeIcon";

const BaitToPlateLegendItem = ({ type = "", text, caveat }) => {
  function getTypeLabel(type) {
    switch (type) {
      case "human-rights":
        return "Human Rights & Labor Concerns";
      case "environmental":
        return "Fishing & Environmental Concerns";
      case "uyghur-labor":
        return "Uyghur Labor";
      case "north-korean-labor":
        return "North Korean Labor";
      default:
        return "";
    }
  }
  const label = getTypeLabel(type);
  return (
    <StyledBaitToPlateLegendItem className={`is-${type}`}>
      <span><strong>{text}</strong>{caveat ? " linked to " : " with "}{label}</span>
    </StyledBaitToPlateLegendItem>
  )
};

export default BaitToPlateLegendItem;

const StyledBaitToPlateLegendItem = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.25em;
  z-index: 1;
  line-height: 1;
  padding: 0.125em 0.4em 0.05em;
  //padding: .5em 0.5em;
  padding: 0.375em 0.5em;
  padding-left: 0.375em;
  border: 1px dotted rgba(0,0,0,0.2);
  border-width: 0 1px 1px 1px;
  &:first-of-type {
    border-top-width: 1px;
  }
  &::before {
    content: "";
    display: block;
    width: 0.75em;
    height: 0.75em;

    position: absolute;
    //top: 0;
    //right: 0;
    //bottom: 0;
    //left: 0;
    border-radius: 0.25em;
    z-index: -1;
    //width: auto;
    //height: auto;
    //box-shadow: inset 0 0 0 3px currentColor;
    background-color: currentColor;
    width: 0.5em;
    height: calc(100% - 0.25em);
    left: 0.25em;
    left: 0;
  }
  &.is-human-rights::before {
    color: var(--color-hr);
  }
  &.is-environmental::before {
    color: var(--color-env);
  }
  &.is-uyghur-labor::before {
    color: var(--color-uyg);
  }
  &.is-north-korean-labor::before {
    color: var(--color-nk);
  }
  span {
    font-size: 0.75em;
    font-weight: 500;
    line-height: 1;
    display: flex;
    gap: 0.375em;
    @media ( min-width: 48em ) {
      font-size: 0.875em;
    }
    strong {
      font-weight: 700;
      width: 2.5em;
      text-align: right;
      display: block;
    }
    small {
      font-style: normal;
      font-size: 1em;
      font-weight: 500;
    }
  }
`;